import {
  Badge,
  Button,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import type { StoreGroup } from 'services/interfaces/storeGroup';

interface StoreGroupTableProps {
  rows: StoreGroup[];
}

const TYPE_LABEL: Record<StoreGroup['type'], string> = {
  CASHBACK: 'Cashback',
  FIDELITY: 'Fidelidade',
  VOUCHER: 'Voucher',
};

function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString('pt-BR');
}

const StoreGroupTable: React.FC<StoreGroupTableProps> = ({ rows }) => {
  return (
    <TableContainer>
      <Table size="sm" variant="simple">
        <Thead>
          <Tr>
            <Th>Nome</Th>
            <Th>Tipo</Th>
            <Th>Criado em</Th>
            <Th textAlign="right">Ações</Th>
          </Tr>
        </Thead>
        <Tbody>
          {rows.map((group) => (
            <Tr key={group.id}>
              <Td>
                <Button
                  as={RouterLink}
                  to={`/store-groups/${group.id}`}
                  variant="link"
                  colorScheme="yooga"
                >
                  {group.name}
                </Button>
              </Td>
              <Td>
                <Badge colorScheme="yooga">{TYPE_LABEL[group.type]}</Badge>
              </Td>
              <Td>{formatDate(group.created_at)}</Td>
              <Td textAlign="right">
                <Button
                  size="xs"
                  variant="outline"
                  as={RouterLink}
                  to={`/store-groups/${group.id}`}
                >
                  Ver / editar
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default StoreGroupTable;
